"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = require("react-dom");

var _Notification = _interopRequireDefault(require("./Notification"));

var blackIcons = _interopRequireWildcard(require("../assets/BlackIcons"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var globalName = "simple-notification";
var initialContent = {
  title: "",
  description: ""
};
var initialOption = {
  type: null,
  duration: 5000,
  position: "top-right",
  width: "400px",
  bold: false,
  speed: 200,
  backgroundColor: "#fff",
  fontColor: "rgb(37,56,88)",
  iconColor: "none",
  icon: null
};
var topRight = {
  top: "1rem",
  right: "1rem"
};
var topLeft = {
  top: "1rem",
  left: "1rem"
};
var bottomRight = {
  bottom: "1rem",
  right: "1rem"
};
var bottomLeft = {
  bottom: "1rem",
  left: "1rem"
};

var Index =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Index, _React$Component);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Index).call(this));
    _this.containerId = null;
    _this.childId = null;
    _this.speed = 200;
    return _this;
  }

  _createClass(Index, null, [{
    key: "success",
    value: function success(_content) {
      var _option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : initialOption;

      var bold = {
        iconColor: "#fff",
        backgroundColor: "rgb(0, 135, 90)",
        fontColor: "#fff"
      };
      var boldOptions = _option.bold && bold;
      var content = _typeof(_content) !== "object" ? {
        title: "Success",
        description: _content
      } : _content;
      _option = _objectSpread({}, _option, {
        icon: blackIcons.Success,
        iconColor: "rgb(54, 179, 126)",
        type: "success"
      });
      return this.open(content, _objectSpread({}, _option, {}, boldOptions));
    }
  }, {
    key: "error",
    value: function error(_content) {
      var _option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : initialOption;

      var bold = {
        iconColor: "#fff",
        backgroundColor: "rgb(222, 53, 11)",
        fontColor: "#fff"
      };
      var boldOptions = _option.bold && bold;
      var content = _typeof(_content) !== "object" ? {
        title: "Error",
        description: _content
      } : _content;
      _option = _objectSpread({}, _option, {
        icon: blackIcons.Error,
        iconColor: "rgb(255, 86, 48)",
        type: "error"
      });
      return this.open(content, _objectSpread({}, _option, {}, boldOptions));
    }
  }, {
    key: "info",
    value: function info(_content) {
      var _option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : initialOption;

      var bold = {
        iconColor: "#fff",
        backgroundColor: "rgb(66, 82, 110)",
        fontColor: "#fff"
      };
      var boldOptions = _option.bold && bold;
      var content = _typeof(_content) !== "object" ? {
        title: "Info",
        description: _content
      } : _content;
      _option = _objectSpread({}, _option, {
        icon: blackIcons.Info,
        iconColor: "rgb(101, 84, 192)",
        type: "info"
      });
      return this.open(content, _objectSpread({}, _option, {}, boldOptions));
    }
  }, {
    key: "warning",
    value: function warning(_content) {
      var _option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : initialOption;

      var bold = {
        iconColor: initialOption.fontColor,
        backgroundColor: "rgb(255, 196, 0)",
        fontColor: initialOption.fontColor
      };
      var boldOptions = _option.bold && bold;
      var content = _typeof(_content) !== "object" ? {
        title: "Warning",
        description: _content
      } : _content;
      _option = _objectSpread({}, _option, {
        icon: blackIcons.Warning,
        iconColor: "rgb(255, 171, 0)",
        type: "warning"
      });
      return this.open(content, _objectSpread({}, _option, {}, boldOptions));
    }
  }]);

  return Index;
}(_react["default"].Component);

_defineProperty(Index, "open", function () {
  var _content = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialContent;

  var _option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : initialOption;

  Index.notification = _react["default"].createRef();
  var positions = ["top-left", "top-right", "bottom-left", "bottom-right"];

  if (!positions.includes(_option.position)) {
    _option.position = "top-right";
  }

  var option = _objectSpread({}, initialOption, {}, _option);

  var placement;
  var speed = option.speed;
  Index.speed = speed;
  var content = _typeof(_content) !== "object" ? {
    title: initialContent.title,
    description: _content
  } : _content;
  var containerId = "".concat(globalName, "-").concat(_option.position);
  var childId = Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7);
  Index.containerId = containerId;
  Index.childId = childId;
  var container = document.getElementById(containerId);

  if (!container) {
    container = document.createElement("div");
    container.setAttribute("id", containerId);

    switch (_option.position) {
      case "top-left":
        placement = topLeft;
        break;

      case "bottom-left":
        placement = bottomLeft;
        break;

      case "bottom-right":
        placement = bottomRight;
        break;

      default:
        placement = topRight;
        break;
    }

    var containerStyles = _objectSpread({
      display: "flex",
      flexDirection: "column",
      position: "fixed"
    }, placement);

    Object.assign(container.style, containerStyles);
    document.body.appendChild(container);
  }

  var child = document.createElement("div");
  child.setAttribute("id", childId);
  var childStyles = {
    margin: "0.25rem 0"
  };
  Object.assign(child.style, childStyles);
  container.appendChild(child);
  (0, _reactDom.render)(_react["default"].createElement(_Notification["default"], _extends({
    ref: Index.notification
  }, {
    childId: childId,
    containerId: containerId
  }, option, content)), child);
  return Index.notification;
});

_defineProperty(Index, "close", function (node) {
  return node && node.current.onClose();
});

_defineProperty(Index, "closeAll", function () {
  var _notificationContainers = document.querySelectorAll("[id^=".concat(globalName, "]"));

  var notificationContainers = Array.from(_notificationContainers);
  notificationContainers.forEach(function (container) {
    var regex = /\w.*-(\w.*)/gm;
    var direction = regex.exec(container.id)[1];
    var allChild = Array.from(container.childNodes);
    allChild.forEach(function (child) {
      return child.firstChild.firstChild.style.animationName = "slide-out-".concat(direction);
    });
    setTimeout(function () {
      allChild.map(function (item) {
        return (0, _reactDom.unmountComponentAtNode)(item);
      });
      document.body.removeChild(container);
    }, Index.speed);
  });
});

var _default = Index;
exports["default"] = _default;